import "./style.css";
import { Button, message, Typography, Input, DatePicker, Modal, Tooltip, Tabs, Dropdown, Steps, AutoComplete, Card, Space, Divider, Progress, Badge, Popconfirm, Checkbox } from "antd";
import React, { useState, useEffect, useCallback, useMemo, useReducer } from "react";
import { catcher } from "../../../firebase/util";
import axios from "axios";
import { useAtom } from "jotai";
import { consultantAtom, reportDataAtom, tableDataSourceAtom } from "../atom/atoms";
import { downloadFileFromStorage } from "../../../firebase/storage/download";
import { getCurrentDate, getCurrentTime, getCurrentYear } from "../../../helper/time";
import { calculateTotals } from "../../extras/testing/other/banner-carbondi";
import store from "../../../redux/store";
import { getAnalysis } from "../../extras/testing/workers/year";
import { designations, findCompanies, firstCompany, getCurrentUserDesignation } from "../../../helper/attribute";
import { fixDecimals, getUniqueProps, removeDuplicates } from "../../../helper/wodash";
import { getForms } from "../../../static/formRoutes";
import { saveAs } from "file-saver";
import CbfReportDownload from "../../extras/testing/CbfReportDownload";
import mergeAndDownloadPDF from "./helper";
import { findForm } from "../../../static/formRoutes";
import CommentsTable from "./CommentsTable";
import { useSelector } from "react-redux";
import { selectCompanies, selectResults, selectSites } from "../../../redux/features/appSlice";
import Loading from "../../../components/loading";
import { QuestionOutlined, DownOutlined, UserOutlined, LogoutOutlined, CheckCircleOutlined, EditOutlined, DownloadOutlined, CommentOutlined, PlusOutlined, SettingOutlined, FileTextOutlined, CloudDownloadOutlined, RocketOutlined, BuildOutlined, SaveOutlined, ReloadOutlined, CloseOutlined, ToolOutlined, NumberOutlined } from "@ant-design/icons";
import AutoCompleteModal from "./AutoCompleteModal";
import { updateUserClicks } from "../../../firebase/user/update";
import { getAllParamsFromLocation } from "../../../helper/loc";
import { getGHGTitle } from "../../../static/ghg.static";
import { arrayToEnglishString, removeLastLine } from "../../../helper/string";
import { get_consultants } from "../../../firebase/super_admins/get_consultants";
import SelectSearch from "../../../components/select/SearchSelect";
import { getCacheOptions, updateCacheOptions } from "../../../firebase/cache/create";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../../firebase/setup";
import { updateCompany } from "../../../firebase/company/update";
import Permissions from "../../super-admin/SuperAdminSectionPages/Permissions";
import Companies from "../../admin/companies";
import ResultFunctions from "./Functions";
import LockData from "./LockData";
import AnalysisConsultant from "./AnalysisConsultant";
import Result from "../../results";
import AnalysisResult from "./AnalysisResult";
import Boundry from "./Boundry";
import { getCurrentPlan } from "../../../helper/plans";

const { TabPane } = Tabs;

// function convertValuesToStrings(list) {
//   var groupedByScope = {};
//   var grandTotals = {};

//   // Group objects by scope
//   list.forEach(function (obj) {
//     var scope = obj["Scope"];
//     if (!groupedByScope[scope]) {
//       groupedByScope[scope] = [];
//     }
//     groupedByScope[scope].push(obj);
//   });

//   var finalList = [];

//   // Process each scope group
//   for (var scope in groupedByScope) {
//     if (groupedByScope.hasOwnProperty(scope)) {
//       var scopeObjects = groupedByScope[scope];
//       var scopeTotals = {};

//       // Process each object within the scope group
//       scopeObjects.forEach(function (obj) {
//         var newObj = {};

//         // Process each key in the object
//         for (var key in obj) {
//           if (obj.hasOwnProperty(key)) {
//             var value = obj[key];

//             // Treat "Scope" key first
//             if (key === "Scope") {
//               newObj[key] = String(value);
//             } else {
//               // Convert numeric values to 2 decimal places and calculate totals
//               if (!isNaN(value) && value !== "") {
//                 value = parseFloat(value)?.toFixed(2);
//                 // Accumulate totals for numeric values within the scope
//                 if (!scopeTotals[key]) {
//                   scopeTotals[key] = 0;
//                 }
//                 scopeTotals[key] += parseFloat(value);

//                 // Accumulate grand totals across all scopes
//                 if (!grandTotals[key]) {
//                   grandTotals[key] = 0;
//                 }
//                 grandTotals[key] += parseFloat(value);
//               }
//               newObj[key] = String(value);
//             }
//           }
//         }
//         finalList.push(newObj);
//       });

//       // Add a summary object for the scope
//       var summaryObj = { Scope: "Scope " + scope + " Total" };

//       // Add totals or empty strings for non-numeric fields
//       for (var key in scopeTotals) {
//         if (scopeTotals.hasOwnProperty(key)) {
//           summaryObj[key] = fixDecimals(scopeTotals[key], 2, true);
//         }
//       }

//       // Ensure that non-numeric fields are represented by empty strings in the total object
//       for (var objKey in scopeObjects[0]) {
//         if (!scopeTotals.hasOwnProperty(objKey) && objKey !== "Scope") {
//           summaryObj[objKey] = "";
//         }
//       }

//       finalList.push(summaryObj);
//     }
//   }

//   // Add a grand total at the end
//   var grandTotalObj = { Scope: "Total (Scope 1, 2 and 3)" };

//   // Populate grand total values or empty strings for non-numeric fields
//   for (var key in grandTotals) {
//     if (grandTotals.hasOwnProperty(key)) {
//       grandTotalObj[key] = fixDecimals(grandTotals[key], 2, true);
//     }
//   }

//   // Ensure that non-numeric fields are represented by empty strings in the grand total object
//   for (var key in list[0]) {
//     if (!grandTotals.hasOwnProperty(key) && key !== "Scope") {
//       grandTotalObj[key] = "";
//     }
//   }

//   finalList.push(grandTotalObj);

//   return finalList;
// }


function convertValuesToStrings(list) {
  const numericFields = ["Location-Based (tCO₂e)", "Market-Based (tCO₂e)"];
  const grouped = {};
  const finalList = [];
  const grandTotals = { "Location-Based (tCO₂e)": 0, "Market-Based (tCO₂e)": 0 };

  // Group by scope
  list.forEach((item) => {
    const scope = String(item.Scope);
    if (!grouped[scope]) grouped[scope] = [];
    // Ensure each item has "Emission Source" field
    const safeItem = {
      ...item,
      "Emission Source": item["Emission Source"] || ""
    };
    grouped[scope].push(safeItem);
  });

  // Helper to clean number string (remove commas) and parse
  const toNumber = (val) => parseFloat(String(val).replace(/,/g, "") || "0");

  // Helper to format number to 2 decimals
  const format = (num) => num.toFixed(2);

  for (const scope in grouped) {
    let scopeTotal = { Scope: `Scope ${scope} Total` };
    numericFields.forEach((field) => (scopeTotal[field] = 0));

    grouped[scope].forEach((item) => {
      const cleanItem = {
        ...item,
        Scope: String(item.Scope),
        "Emission Source": item["Emission Source"] || ""  // Ensure Emission Source is always present
      };

      numericFields.forEach((field) => {
        const value = toNumber(cleanItem[field] || "0"); // Handle missing numeric fields
        cleanItem[field] = format(value);
        scopeTotal[field] += value;
        grandTotals[field] += value;
      });

      finalList.push(cleanItem);
    });

    // Format scope totals
    numericFields.forEach((field) => {
      scopeTotal[field] = format(scopeTotal[field]);
    });

    // Add empty for non-numeric field
    scopeTotal["Emission Source"] = "";
    finalList.push(scopeTotal);
  }

  // Add grand total row
  const grandTotalRow = { Scope: "Total (Scope 1, 2 and 3)", "Emission Source": "" };
  numericFields.forEach((field) => {
    grandTotalRow[field] = format(grandTotals[field]);
  });

  finalList.push(grandTotalRow);
  return finalList;
}


function convertListToColumns(list) {
  return list.map((item) => {
    return {
      Data: item.data,
      "Source of data": item.source || "",
      "Verifier comments": item.verifier || "",
    };
  });
}

function singleLineString(str) {
  return str.replace(/\s+/g, " ").trim();
}

function combineChildrenghg(data, year) {
  let combinedChildrenghg = [];

  // Iterate through each item in dataSource
  data.dataSource.forEach((scope) => {
    if (scope.childrenghg && Array.isArray(scope.childrenghg)) {
      // Filter based on the year provided in the params
      const filteredGHG = scope.childrenghg.filter((item) => item[year] !== undefined);
      combinedChildrenghg = combinedChildrenghg.concat(filteredGHG);
    }
  });

  return combinedChildrenghg;
}

const fieldConfig = {
  date: { type: "text", info: "The date of the report (DD/MM/YYYY format)" },
  fullName: { type: "text", info: "Full name of user." },
  marketBasedEmission: { type: "text", info: "Market based emission value" },
  locationBasedEmission: { type: "text", info: "Location based emission value" },
  companyName: { type: "text", info: "Name of the company" },
  reportStartDate: { type: "text", info: "Follow DD/MM/YYYY format" },
  reportEndDate: { type: "text", info: "Follow DD/MM/YYYY format" },
  accuracyComments: { type: "autocomplete", info: "Comments on the accuracy of the report" },
  recommendations: { type: "autocomplete", info: "Write recommendations separated by a new line." },
  consultant_signature: { type: "text", info: "Consultant's signature URL (signature to be used in report)" },
  finalComments: { type: "autocomplete", info: "Sign off comments" },

  consultant_details: { type: "textarea", info: "Details about the consultant" },
  consultant_summary: { type: "textarea", info: "Consultant summary" },
};

const Verification = ({ rerender, useWtt, setUseWtt, year, setYear }) => {
  const results = useSelector(selectResults);
  const [consultant, setConsultant] = useAtom(consultantAtom);
  const [tableDataSource, setTableDataSource] = useState(tableDataSourceAtom);
  const [calculatedCommentsTable, setCalculatedCommentsTable] = useState([]);
  const [reportData, setReportData] = useAtom(reportDataAtom);

  const [reviewer, setReviewer] = useState();
  const [authorizer, setAuthorizer] = useState();
  const sites = useSelector(selectSites);
  const consultants = useSelector((state) => state.superAdminData.consultants);
  const [currentStep, setCurrentStep] = useState(0);
  const [reportTypeModalVisible, setReportTypeModalVisible] = useState(false);
  const [consultantsLoaded, setConsultantsLoaded] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const [autocompleteOptions, setAutocompleteOptions] = useState({
    accuracyComments: [],
    recommendations: [],
    finalComments: []
  });

  const [isAddOptionModalVisible, setIsAddOptionModalVisible] = useState(false);
  const [newOptionValue, setNewOptionValue] = useState("");
  const [companies, setCompanies] = useState(selectCompanies(store.getState()));
  const [currentField, setCurrentField] = useState("");
  const [autoCompleteModalVisible, setAutoCompleteModalVisible] = useState(false);
  const [currentEditingFieldKey, setCurrentEditingFieldKey] = useState("");
  const group = useSelector((state) => state.app.groups)?.[0];

  // Save/Load state
  const [loadedData, setLoadedData] = useState(null);
  const [savedSlots, setSavedSlots] = useState([]);
  const [currentDividedRecords, setCurrentDividedRecords] = useState({});
  const [slotsLoading, setSlotsLoading] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [isAutoSaving, setIsAutoSaving] = useState(false);
  const [autoSaveTimeout, setAutoSaveTimeout] = useState(null);
  const [updatingSlot, setUpdatingSlot] = useState(null);
  const [deletingSlot, setDeletingSlot] = useState(null);
  const [forceUpdate, setForceUpdate] = useState(0);
  const [, forceRender] = useReducer(x => x + 1, 0);
  const [isLoadingSlot, setIsLoadingSlot] = useState(false);
  const [isUsingOldSlotData, setIsUsingOldSlotData] = useState(false);
  const [emissionMismatchWarning, setEmissionMismatchWarning] = useState(null);

  // Settings modal state
  const [settingsModalVisible, setSettingsModalVisible] = useState(false);
  const [useCommonCache, setUseCommonCache] = useState(true);

  console.log("Group", group)

  const isMultiCompany = companies.length > 1;

  // Helper function to compare emissions with decimal tolerance
  const compareEmissions = useCallback((oldValue, newValue) => {
    if (!oldValue || !newValue) return false;
    const oldNum = parseFloat(String(oldValue).replace(/,/g, ''));
    const newNum = parseFloat(String(newValue).replace(/,/g, ''));
    return Math.floor(oldNum) === Math.floor(newNum);
  }, []);

  // Helper function to get slot cache key (always per company + year)
  const getSlotCacheKey = useCallback(() => {
    const companyName = group?.name ?? firstCompany()?.title;
    return companyName ? `${companyName}_verification_slots_${year}` : null;
  }, [group?.name, year]);

  // Save/Load utility functions
  const loadSavedSlots = useCallback(async () => {
    try {
      setSlotsLoading(true);

      const cacheKey = getSlotCacheKey();
      if (!cacheKey) {
        setSavedSlots([]);
        return;
      }

      const slotsData = await getCacheOptions(cacheKey, "_slots");
      const slots = [];

      if (slotsData) {
        for (let i = 1; i <= 3; i++) {
          const slotKey = `slot_${i}`;
          if (slotsData[slotKey]) {
            slots.push({
              slotNumber: i,
              ...slotsData[slotKey],
              // Add a unique key for React rendering
              key: `${year}_${i}_${slotsData[slotKey].saveDate || Date.now()}`
            });
          }
        }
      }

      setSavedSlots(slots);
    } catch (error) {
      console.error('Error loading saved slots:', error);
      setSavedSlots([]);
    } finally {
      setSlotsLoading(false);
    }
  }, [year, forceRender, getSlotCacheKey]);

  const saveToSlot = useCallback(async (slotNumber, slotName, showMessage = true) => {
    try {
      const cacheKey = getSlotCacheKey();
      if (!cacheKey) return;

      // Helper function to recursively remove undefined values
      const removeUndefined = (obj) => {
        if (obj === null || obj === undefined) return null;
        if (Array.isArray(obj)) {
          return obj.map(removeUndefined).filter(item => item !== null && item !== undefined);
        }
        if (typeof obj === 'object') {
          const cleaned = {};
          Object.keys(obj).forEach(key => {
            const value = removeUndefined(obj[key]);
            if (value !== undefined && value !== null) {
              cleaned[key] = value;
            }
          });
          return cleaned;
        }
        return obj;
      };

      // Filter out auto-calculated fields from comments table data
      const filteredTableDataSource = tableDataSource.map(item => {
        const { calculatedTotalEmissions, calculatedPercentage, calculatedPercentageDisplay,
          calculatedMateriality, calculatedUncertainty, calculatedUncertaintyDisplay,
          calculatedErrorMargin, calculatedErrorMarginDisplay, totalEmissions,
          percentage, materiality, uncertainty, errorMargin, ...restItem } = item;
        return removeUndefined(restItem);
      });

      // Get existing slot data to preserve slot name if not provided
      const existingSlots = await getCacheOptions(cacheKey, "_slots");
      const existingSlot = existingSlots?.[`slot_${slotNumber}`];
      const preservedSlotName = slotName || existingSlot?.slotName || `Verification Save ${slotNumber}`;

      const saveData = removeUndefined({
        slotName: preservedSlotName,
        saveDate: new Date().toISOString(),
        data: {
          useWtt,
          year,
          reviewer,
          authorizer,
          reportData: {
            ...reportData,
            // Ensure these critical fields are saved
            accuracyComments: reportData?.accuracyComments || "",
            recommendations: reportData?.recommendations || "",
            finalComments: reportData?.finalComments || "",
          },
          commentsTableData: {
            dataSource: filteredTableDataSource,
            dividedRecords: currentDividedRecords,
            // Save the full computed table data to avoid recalculation
            computedTableData: calculatedCommentsTable,
          },
          currentStep,
          calculatedCommentsTable,
        }
      });

      // Optimistic update - update UI immediately
      setSavedSlots(prev => {
        const existingIndex = prev.findIndex(slot => slot.slotNumber === slotNumber);
        const updatedSlot = {
          slotNumber,
          slotName: saveData.slotName,
          saveDate: saveData.saveDate,
          data: saveData.data,
          key: `${year}_${slotNumber}_${saveData.saveDate}`
        };

        if (existingIndex >= 0) {
          const newSlots = [...prev];
          newSlots[existingIndex] = updatedSlot;
          return newSlots;
        } else {
          return [...prev, updatedSlot];
        }
      });

      // Save to cache
      await updateCacheOptions(cacheKey, { [`slot_${slotNumber}`]: saveData }, "_slots");

      if (showMessage) {
        message.success(`Progress saved to Slot ${slotNumber}`);
      }
    } catch (error) {
      console.error('Error saving data:', error);
      if (showMessage) {
        message.error('Save failed. Please try again.');
      }
      // Revert optimistic update on error
      loadSavedSlots();
    }
  }, [useWtt, year, reviewer, authorizer, reportData, tableDataSource, currentStep, calculatedCommentsTable, currentDividedRecords, loadSavedSlots, getSlotCacheKey]);

  const loadFromSlot = useCallback(async (slotNumber) => {
    try {
      // Set loading flag first, before any other state updates
      setIsLoadingSlot(true);

      const cacheKey = getSlotCacheKey();
      if (!cacheKey) {
        message.error('Cache key not available. Please try again.');
        setIsLoadingSlot(false);
        return;
      }

      const slotsData = await getCacheOptions(cacheKey, "_slots");
      const slotData = slotsData?.[`slot_${slotNumber}`];

      if (slotData && slotData.data) {
        const { data } = slotData;

        console.log('Loading slot data:', {
          slotNumber,
          loadedData: data,
          accuracyComments: data.reportData?.accuracyComments,
          recommendations: data.reportData?.recommendations,
          finalComments: data.reportData?.finalComments,
        });

        // Use setTimeout to batch all state updates and ensure they happen after isLoadingSlot is set
        setTimeout(() => {
          // Load all data immediately
          setUseWtt(data.useWtt ?? true);
          setReviewer(data.reviewer || '');
          setAuthorizer(data.authorizer || '');

          if (data.reportData) {
            setReportData(prevData => ({
              ...prevData,
              ...data.reportData,
              // Ensure these critical fields are restored
              accuracyComments: data.reportData.accuracyComments || "",
              recommendations: data.reportData.recommendations || "",
              finalComments: data.reportData.finalComments || "",
            }));
          }

          // Set loaded data for CommentsTable
          setLoadedData(data);

          if (data.commentsTableData?.dataSource) {
            setTableDataSource(data.commentsTableData.dataSource);
          }

          if (data.currentStep !== undefined) {
            setCurrentStep(data.currentStep);
          }

          if (data.calculatedCommentsTable) {
            setCalculatedCommentsTable(data.calculatedCommentsTable);
          }

          if (data.commentsTableData?.dividedRecords) {
            setCurrentDividedRecords(data.commentsTableData.dividedRecords);
          }

          setSelectedSlot(slotNumber);
          setIsUsingOldSlotData(true);
          message.success(`Data loaded from Slot ${slotNumber}`);

          // Add a longer delay to ensure all state updates are complete before allowing getReportData to run
          setTimeout(() => setIsLoadingSlot(false), 200);
        }, 10);
      } else {
        message.error(`No data found in Slot ${slotNumber}`);
        setIsLoadingSlot(false);
      }
    } catch (error) {
      console.error('Error loading data:', error);
      message.error('Load failed. Please try again.');
      setIsLoadingSlot(false);
    }
  }, [setReportData, setTableDataSource, year, getSlotCacheKey]);

  const deleteFromSlot = useCallback(async (slotNumber) => {
    try {
      setDeletingSlot(slotNumber);

      if (selectedSlot === slotNumber) {
        setSelectedSlot(null);
      }

      // Optimistic update - remove from UI immediately
      setSavedSlots(prev => {
        const newSlots = prev.filter(slot => slot.slotNumber !== slotNumber);
        console.log('Deleting slot - before:', prev.length, 'after:', newSlots.length);
        return newSlots;
      });

      const cacheKey = getSlotCacheKey();
      if (!cacheKey) return;

      // Get existing slots and remove the specific slot
      const existingSlots = await getCacheOptions(cacheKey, "_slots");
      if (existingSlots && existingSlots[`slot_${slotNumber}`]) {
        const updatedSlots = { ...existingSlots };
        delete updatedSlots[`slot_${slotNumber}`];

        // Use setDoc without merge to completely replace the document
        const cacheDocRef = doc(db, "Cache", `${cacheKey}_slots`);

        // If no slots remain, set to empty object instead of null
        if (Object.keys(updatedSlots).length === 0) {
          await setDoc(cacheDocRef, {});
        } else {
          await setDoc(cacheDocRef, updatedSlots);
        }
      }

      message.success(`Slot ${slotNumber} deleted`);
      rerender()
    } catch (error) {
      console.error('Error deleting slot:', error);
      message.error('Delete failed. Please try again.');
      // Revert optimistic update on error
      loadSavedSlots();
    } finally {
      setDeletingSlot(null);
    }
  }, [year, selectedSlot, loadSavedSlots, getSlotCacheKey]);


  console.log("SLOTS", savedSlots)

  const updateSlotName = useCallback(async (slotNumber, newName) => {
    if (!newName || !newName.trim()) return;

    try {
      setUpdatingSlot(slotNumber);
      const cacheKey = getSlotCacheKey();
      if (!cacheKey) return;

      const existingSlots = await getCacheOptions(cacheKey, "_slots");
      const existingSlot = existingSlots?.[`slot_${slotNumber}`];

      // Optimistic update - update UI immediately
      const updatedName = newName.trim();
      const updateTime = new Date().toISOString();
      setSavedSlots(prev => {
        const existing = prev.find(slot => slot.slotNumber === slotNumber);
        console.log('Updating slot name - existing:', existing, 'new name:', updatedName);

        if (existing) {
          const newSlots = prev.map(slot =>
            slot.slotNumber === slotNumber
              ? {
                ...slot,
                slotName: updatedName,
                saveDate: updateTime,
                key: `${year}_${slotNumber}_${updateTime}`
              }
              : slot
          );
          console.log('Updated existing slot:', newSlots.find(s => s.slotNumber === slotNumber));
          return newSlots;
        } else {
          const newSlot = {
            slotNumber,
            slotName: updatedName,
            saveDate: updateTime,
            key: `${year}_${slotNumber}_${updateTime}`,
            data: {
              useWtt: true,
              year,
              reviewer: "",
              authorizer: "",
              reportData: {
                accuracyComments: "",
                recommendations: "",
                finalComments: "",
              },
              commentsTableData: {
                dataSource: [],
                dividedRecords: {},
              },
              currentStep: 0,
              calculatedCommentsTable: [],
            }
          };
          console.log('Created new slot:', newSlot);
          return [...prev, newSlot];
        }
      });

      if (existingSlot) {
        // Update existing slot
        const updatedSlot = {
          ...existingSlot,
          slotName: updatedName
        };
        await updateCacheOptions(cacheKey, { [`slot_${slotNumber}`]: updatedSlot }, "_slots");
      } else {
        // Create a new slot with just the name (placeholder)
        const newSlot = {
          slotName: updatedName,
          saveDate: new Date().toISOString(),
          data: {
            useWtt: true,
            year,
            reviewer: "",
            authorizer: "",
            reportData: {
              accuracyComments: "",
              recommendations: "",
              finalComments: "",
            },
            commentsTableData: {
              dataSource: [],
              dividedRecords: {},
            },
            currentStep: 0,
            calculatedCommentsTable: [],
          }
        };
        await updateCacheOptions(cacheKey, { [`slot_${slotNumber}`]: newSlot }, "_slots");
      }

      message.success('Slot name updated');
      rerender()
    } catch (error) {
      console.error('Error updating slot name:', error);
      message.error('Update failed. Please try again.');
      // Revert optimistic update on error
      loadSavedSlots();
    } finally {
      setUpdatingSlot(null);
    }
  }, [year, loadSavedSlots, getSlotCacheKey]);

  const handleSlotNameEdit = useCallback((slotNumber, currentName) => {
    const newName = window.prompt(
      `Enter name for Slot ${slotNumber}:`,
      currentName || `Slot ${slotNumber}`
    );

    if (newName !== null && newName.trim() !== currentName) {
      updateSlotName(slotNumber, newName.trim());
    }
  }, [updateSlotName]);

  // Auto-save functionality
  const autoSave = useCallback(() => {
    // Save from step 1 onwards (step 0 is configuration step, don't save that)
    if (selectedSlot && currentStep > 0) {
      setIsAutoSaving(true);
      // Pass null as slotName to preserve existing slot name
      saveToSlot(selectedSlot, null, false).finally(() => {
        setTimeout(() => setIsAutoSaving(false), 1000);
      });
    }
  }, [selectedSlot, currentStep, saveToSlot]);

  // Debounced auto-save
  useEffect(() => {
    // Save from step 1 onwards (step 0 is configuration step, don't save that)
    if (selectedSlot && currentStep > 0 && !isLoadingSlot) {
      console.log('Auto-save useEffect triggered, scheduling auto-save in 1 second');
      if (autoSaveTimeout) {
        clearTimeout(autoSaveTimeout);
      }

      const timeout = setTimeout(() => {
        console.log('Auto-save executing now');
        autoSave();
      }, 1000); // Auto-save after 1 second of inactivity

      setAutoSaveTimeout(timeout);

      return () => clearTimeout(timeout);
    } else {
      console.log('Auto-save useEffect triggered but conditions not met:', { selectedSlot, currentStep, isLoadingSlot });
    }
  }, [reportData, tableDataSource, currentDividedRecords, calculatedCommentsTable, useWtt, reviewer, authorizer, selectedSlot, currentStep, autoSave, isLoadingSlot]);

  // Load consultants first
  useEffect(() => {
    const loadConsultants = async () => {
      try {
        await get_consultants();
        setConsultantsLoaded(true);
      } catch (error) {
        console.error("Error loading consultants:", error);
        message.error("Failed to load consultants");
      }
    };

    if (!consultants) {
      loadConsultants();
    } else {
      setConsultantsLoaded(true);
    }
  }, [consultants]);

  // Load saved slots on mount and when year changes
  useEffect(() => {
    loadSavedSlots();
    setSelectedSlot(null); // Clear selected slot when year changes
    setIsUsingOldSlotData(false); // Reset old slot data flag
    setEmissionMismatchWarning(null); // Clear any emission warnings
  }, [loadSavedSlots, year]);

  // Debug effect to track savedSlots changes and force re-render
  useEffect(() => {
    console.log('savedSlots changed:', savedSlots.length, savedSlots);
    // Force a re-render when savedSlots changes
    setForceUpdate(prev => prev + 1);
  }, [savedSlots]);

  // Helper function to get cache key
  const getCacheKey = useCallback(() => {
    return useCommonCache ? "commonVerificationCompany" : (group?.name ?? firstCompany()?.title);
  }, [useCommonCache, group, firstCompany()]);

  // Load autocomplete suggestions from cache
  useEffect(() => {
    const loadAutocompleteOptions = async () => {
      try {
        const cacheKey = getCacheKey();
        if (!cacheKey) return;

        const [accuracyCache, recommendationsCache, finalCommentsCache] = await Promise.all([
          getCacheOptions(cacheKey, "_accuracy_comments"),
          getCacheOptions(cacheKey, "_recommendations"),
          getCacheOptions(cacheKey, "_final_comments")
        ]);

        setAutocompleteOptions({
          accuracyComments: accuracyCache ? Object.values(accuracyCache) : [],
          recommendations: recommendationsCache ? Object.values(recommendationsCache) : [],
          finalComments: finalCommentsCache ? Object.values(finalCommentsCache) : []
        });
      } catch (error) {
        console.error("Error loading autocomplete options:", error);
      }
    };

    loadAutocompleteOptions();
  }, [getCacheKey]);

  // Helper function to get the last day of a month
  const getLastDayOfMonth = (month, year) => {
    // month is 1-indexed (1 = January, 12 = December)
    const date = new Date(year, month, 0); // Day 0 gets the last day of the previous month
    return date.getDate();
  };

  // Helper function to convert month name to number
  const getMonthNumber = (monthName) => {
    const months = {
      'january': 1, 'jan': 1,
      'february': 2, 'feb': 2,
      'march': 3, 'mar': 3,
      'april': 4, 'apr': 4,
      'may': 5,
      'june': 6, 'jun': 6,
      'july': 7, 'jul': 7,
      'august': 8, 'aug': 8,
      'september': 9, 'sep': 9,
      'october': 10, 'oct': 10,
      'november': 11, 'nov': 11,
      'december': 12, 'dec': 12
    };

    if (typeof monthName === 'number') return monthName;
    if (typeof monthName === 'string') {
      const num = parseInt(monthName);
      if (!isNaN(num)) return num;
      return months[monthName.toLowerCase()] || null;
    }
    return null;
  };

  // Helper function to format date based on reporting year starting month
  const getReportingDates = (reportingYear, reportingStartMonth) => {
    if (!reportingStartMonth) {
      // Fallback to January-December if no reporting start month is set
      return {
        startDate: "01/01/" + reportingYear,
        endDate: "31/12/" + reportingYear,
      };
    }

    const startMonth = getMonthNumber(reportingStartMonth);
    if (!startMonth) {
      // Fallback if month conversion fails
      return {
        startDate: "01/01/" + reportingYear,
        endDate: "31/12/" + reportingYear,
      };
    }

    const endMonth = startMonth === 1 ? 12 : startMonth - 1; // Previous month to the reporting start month

    // For start date: first day of reporting year starting month in the selected year
    const startYear = Number(reportingYear);

    // For end date: last day of the month before reporting start month
    // If start month is January, end year is same year (Jan-Dec)
    // If start month is not January, end year is next year (e.g., Apr 2025 - Mar 2026)
    const endYear = startMonth === 1 ? Number(reportingYear) : Number(reportingYear) + 1;

    const endLastDay = getLastDayOfMonth(endMonth, endYear);
    const formatMonth = (month) => month.toString().padStart(2, '0');

    return {
      startDate: `01/${formatMonth(startMonth)}/${startYear}`,
      endDate: `${endLastDay}/${formatMonth(endMonth)}/${endYear}`,
    };
  };

  const getReportData = async (consultant, preserveExistingComments = false, oldSlotData = null) => {
    console.log('getReportData called with preserveExistingComments:', preserveExistingComments, 'oldSlotData:', !!oldSlotData);
    const company = firstCompany();
    const options = {
      wtt: useWtt ? "Included" : "Excluded",
      type: "Location",
      reporting: "All",
      sites: getCurrentUserDesignation() !== designations.group_admin ? [findCompanies()[0]?.id] : findCompanies()?.map((c) => c.id),
    };

    const locationAnalysis = getAnalysis(store.getState().app.results, options);
    const marketAnalysis = getAnalysis(store.getState().app.results, {
      ...options,
      type: "Market",
    });

    const locGhg = combineChildrenghg(locationAnalysis, year);
    const mktGhg = combineChildrenghg(marketAnalysis, year);
    const locationTotals = calculateTotals(locationAnalysis.dataSource, year, true);
    const marketTotals = calculateTotals(marketAnalysis.dataSource, year, true);

    const emissionTable = [];

    console.log(locGhg, mktGhg, "ghgs")
    locGhg.forEach((item, index) => {
      const { scope, name } = item;
      const mktItem = mktGhg.find((m) => m.scope === scope && m.name === name);
      emissionTable.push({
        Scope: scope,
        "Emission Source": getGHGTitle(name) || "", // Ensure this is never undefined
        "Location-Based (tCO₂e)": fixDecimals(item[year], 2, true),
        "Market-Based (tCO₂e)": fixDecimals(mktItem?.[year], 2, true),
      });
    });
    console.log("emission_tables", emissionTable)

    const findc = (fullName) => {
      const x = consultants?.find((c) => c.firstName + " " + c.lastName === fullName);
      return x;
    };

    const rysp = firstCompany()?.reporting_year_starting_month;
    const { startDate, endDate } = getReportingDates(year, rysp);
    console.log('Verification.js - Reporting dates:', {
      year,
      reportingStartMonth: rysp,
      startDate,
      endDate
    });

    // Calculate new emission values
    const newMarketBasedEmission = fixDecimals(marketTotals);
    const newLocationBasedEmission = fixDecimals(locationTotals);

    // Check for emission mismatches if we have old slot data
    let useOldEmissions = false;
    if (oldSlotData) {
      const oldMarketBased = oldSlotData.marketBasedEmission;
      const oldLocationBased = oldSlotData.locationBasedEmission;

      console.log('Comparing emissions:', {
        oldMarketBased,
        newMarketBased: newMarketBasedEmission,
        oldLocationBased,
        newLocationBased: newLocationBasedEmission
      });

      const marketMatch = compareEmissions(oldMarketBased, newMarketBasedEmission);
      const locationMatch = compareEmissions(oldLocationBased, newLocationBasedEmission);

      console.log('Match results:', { marketMatch, locationMatch });

      if (!marketMatch || !locationMatch) {
        console.log('Setting emission mismatch warning');
        setEmissionMismatchWarning({
          oldMarketBased,
          newMarketBased: newMarketBasedEmission,
          oldLocationBased,
          newLocationBased: newLocationBasedEmission,
        });
      } else {
        console.log('No mismatch detected, clearing warning');
        setEmissionMismatchWarning(null);
      }

      useOldEmissions = true;
    } else {
      console.log('No oldSlotData provided, using fresh calculations');
      setEmissionMismatchWarning(null);
    }

    // Preserve existing comment values if requested
    const existingComments = preserveExistingComments ? {
      accuracyComments: reportData?.accuracyComments || "",
      recommendations: reportData?.recommendations || "",
      finalComments: reportData?.finalComments || "",
    } : {
      accuracyComments: "",
      recommendations: "",
      finalComments: "",
    };

    return {
      date: getCurrentDate(),
      fullName: store.getState().user.doc.firstName + " " + store.getState().user.doc.lastName,
      firstName: store.getState().user.doc.firstName,
      marketBasedEmission: useOldEmissions ? oldSlotData.marketBasedEmission : newMarketBasedEmission,
      locationBasedEmission: useOldEmissions ? oldSlotData.locationBasedEmission : newLocationBasedEmission,
      companyName: group?.name ?? firstCompany()?.title,
      startDate,
      endDate,
      reportStartDate: startDate,
      reportEndDate: endDate,
      ...existingComments,
      // consultant
      consultantEmail: consultant.email,
      //--details
      consultant_details: consultant.details_for_template,
      consultant_details_inline: singleLineString(removeLastLine(consultant.details_for_template)),
      consultant_details_without_phone: removeLastLine(consultant.details_for_template),
      consultant_signature: await downloadFileFromStorage(consultant.signature, "s.png", true),
      consultant_summary: consultant.summary_for_template,
      // reviwer
      reviewer_details_without_phone: removeLastLine(findc(reviewer)?.details_for_template, 2),
      reviewer_summary: findc(reviewer)?.summary_for_template,

      //authorizer
      authorizer_details_without_phone: removeLastLine(findc(authorizer)?.details_for_template, 2),
      authorizer_summary: findc(authorizer)?.summary_for_template,

      formNames: getForms().map(form => form.title),
      formCommentsTable: [],
      year,
      // pro
      companyAbout: `${company.title} is ${company.about}`,
      emissionTable: useOldEmissions && oldSlotData.emissionTable ? oldSlotData.emissionTable : convertValuesToStrings(emissionTable),
      companyCountries: arrayToEnglishString(removeDuplicates(sites.map((site) => site.country))),
    };
  };

  useEffect(() => {
    if (consultant && consultantsLoaded && !isLoadingSlot) {
      // Preserve existing comments if reportData already exists (i.e., when updating due to parameter changes)
      const preserveComments = reportData !== null && reportData !== undefined;
      console.log('useEffect calling getReportData, preserveComments:', preserveComments, 'isLoadingSlot:', isLoadingSlot, 'isUsingOldSlotData:', isUsingOldSlotData);

      // If we're using old slot data, pass it to getReportData for comparison
      const oldSlotData = isUsingOldSlotData && reportData ? reportData : null;
      console.log('Passing oldSlotData to getReportData:', !!oldSlotData, oldSlotData?.marketBasedEmission, oldSlotData?.locationBasedEmission);

      getReportData(consultant, preserveComments, oldSlotData).then(setReportData);
    }
  }, [consultant, year, useWtt, reviewer, authorizer, consultantsLoaded, isLoadingSlot, loadedData, selectedSlot, isUsingOldSlotData]);

  useEffect(() => {
    catcher(async () => {
      const { auth_key } = getAllParamsFromLocation();
      if (auth_key) {
        const { data } = await axios.post(`${process.env.REACT_APP_BE}/api/user/login/consultant`, { direct_using_uid: auth_key });
        if (!data.consultant) return message.error("Error getting consultant information");
        setConsultant(data);
      }
    }, {});
  }, []);

  useEffect(() => {
    if (results) {
      const availableForms = getForms();
      setTableDataSource(availableForms.map((form) => ({
        data: form.title,
        formName: form.name,
        key: form.name
      })));
    }
  }, [results]);

  const handleDownloadReport = useCallback(async (type = 1) => {
    setReportTypeModalVisible(false);
    setIsDownloading(true);
    setDownloadProgress(0);

    // Simulate progress for better UX
    const progressInterval = setInterval(() => {
      setDownloadProgress(prev => {
        if (prev >= 90) {
          clearInterval(progressInterval);
          return prev;
        }
        return prev + Math.random() * 15;
      });
    }, 200);

    catcher(
      async () => {
        let inputFile;

        function removeLowercaseKeys(arr) {
          return arr.map(obj => {
            const newObj = {};
            for (const key in obj) {
              if (key[0] !== key[0].toLowerCase()) {
                newObj[key] = obj[key];
              }
            }
            return newObj;
          });
        }

        if (type == 1) {
          await updateUserClicks("download_pdf_report");
          inputFile = await downloadFileFromStorage("assets/verification_template.docx", "template.docx", true);
        } else if (type == 2) {
          inputFile = await downloadFileFromStorage("assets/verification_template_pro.docx", "template.docx", true);
        } else {
          inputFile = await downloadFileFromStorage("assets/verification_template_dc.docx", "template.docx", true);
        }

        setDownloadProgress(70);

        const dataToSend = {
          inputFile,
          context: {
            ...reportData,
            startDate: reportData.reportStartDate,
            endDate: reportData.reportEndDate,
            recommendations: reportData.recommendations.split("\n"),
            formCommentsTable: removeLowercaseKeys(calculatedCommentsTable),
          },
        };

        const result = await axios.post("https://testing-wasilislam.pythonanywhere.com/docx/template", dataToSend, { responseType: "blob" });

        setDownloadProgress(100);
        saveAs(result.data, `${group?.name ? group?.name : firstCompany()?.title} Verification Report.docx`);

        clearInterval(progressInterval);
        setTimeout(() => {
          setIsDownloading(false);
          setDownloadProgress(0);
        }, 1000);
      },
      {
        loading_msg: "Generating your report...",
        onFinally: () => {
          clearInterval(progressInterval);
          setIsDownloading(false);
          setDownloadProgress(0);
        }
      }
    );
  }, [reportData, tableDataSource]);

  const handleChange = useCallback((key, value) => {
    setReportData((prevData) => ({ ...prevData, [key]: value }));
  }, [setReportData]);

  // Handle adding new autocomplete option
  const handleAddNewAutocompleteOption = useCallback(async () => {
    if (newOptionValue.trim() && currentField) {
      const cacheKey = getCacheKey();
      if (!cacheKey) return;

      const cacheSuffix = `_${currentField.replace('Comments', '_comments')}`;
      const currentTime = getCurrentTime();

      // Update cache with new option
      await updateCacheOptions(cacheKey, { [currentTime]: newOptionValue.trim() }, cacheSuffix);

      // Update local state
      setAutocompleteOptions(prev => ({
        ...prev,
        [currentField]: [...prev[currentField], newOptionValue.trim()]
      }));

      // Close modal and reset
      setIsAddOptionModalVisible(false);
      setNewOptionValue("");
      setCurrentField("");
    }
  }, [newOptionValue, currentField, getCacheKey]);

  // Show add option modal
  const showAddOptionModal = useCallback((fieldKey) => {
    setCurrentField(fieldKey);
    setIsAddOptionModalVisible(true);
  }, []);

  // Handle saving from autocomplete modal
  const handleAutoCompleteModalSave = useCallback((value) => {
    if (currentEditingFieldKey) {
      handleChange(currentEditingFieldKey, value);
    }
    setAutoCompleteModalVisible(false);
    setCurrentEditingFieldKey("");
  }, [currentEditingFieldKey, handleChange]);

  // Handle adding suggestion from autocomplete modal
  const handleAddSuggestionFromAutoCompleteModal = useCallback(async (suggestion, fieldKey) => {
    const cacheKey = getCacheKey();
    if (!cacheKey) return;

    const cacheSuffix = `_${fieldKey.replace('Comments', '_comments')}`;
    const currentTime = getCurrentTime();

    // Update cache with new option
    await updateCacheOptions(cacheKey, { [currentTime]: suggestion }, cacheSuffix);

    // Update local state
    setAutocompleteOptions(prev => ({
      ...prev,
      [fieldKey]: [...prev[fieldKey], suggestion]
    }));
  }, [getCacheKey]);

  // Handle removing suggestion from autocomplete modal
  const handleRemoveSuggestionFromAutoCompleteModal = useCallback(async (suggestion, fieldKey) => {
    try {
      const cacheKey = getCacheKey();
      if (!cacheKey) return;

      const cacheSuffix = `_${fieldKey.replace('Comments', '_comments')}`;

      // Get current cache data
      const currentCache = await getCacheOptions(cacheKey, cacheSuffix);

      if (currentCache) {
        // Find the key(s) that have this suggestion as value and remove them
        const updatedCache = {};
        Object.keys(currentCache).forEach(key => {
          if (currentCache[key] !== suggestion) {
            updatedCache[key] = currentCache[key];
          }
        });

        // Update cache with the filtered data
        const cacheDocRef = doc(db, "Cache", `${cacheKey}${cacheSuffix}`);
        await setDoc(cacheDocRef, updatedCache);
      }

      // Update local state
      setAutocompleteOptions(prev => ({
        ...prev,
        [fieldKey]: prev[fieldKey].filter(s => s !== suggestion)
      }));
    } catch (error) {
      console.error('Error removing suggestion from cache:', error);
    }
  }, [getCacheKey]);

  const updateToNewValues = useCallback(async () => {
    if (!emissionMismatchWarning || !consultant) return;

    try {
      // Get fresh report data with new emission values
      const freshReportData = await getReportData(consultant, true, null); // null = don't use old data

      // Update only emission-related fields while preserving everything else
      setReportData(prevData => ({
        ...prevData,
        // Update emission values to new ones
        marketBasedEmission: freshReportData.marketBasedEmission,
        locationBasedEmission: freshReportData.locationBasedEmission,
        emissionTable: freshReportData.emissionTable,
        // Keep all other fields unchanged (comments, dates, consultant info, etc.)
      }));

      // Clear old slot data flag to force fresh calculations in comments table
      setIsUsingOldSlotData(false);
      setLoadedData(null); // Clear loaded data to force fresh calculations

      // Clear the mismatch warning
      setEmissionMismatchWarning(null);

      message.success('Updated to new emission values. Comments table will recalculate with fresh data.');
    } catch (error) {
      console.error('Error updating to new values:', error);
      message.error('Failed to update values. Please try again.');
    }
  }, [emissionMismatchWarning, consultant, getReportData, setReportData]);

  const renderField = useCallback((key, fieldConfigItem) => {
    const label = key
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .replaceAll("_", " ");
    const commonProps = { key, className: "report-data-field" };
    const isEmpty = !reportData[key] || (typeof reportData[key] === "string" && reportData[key].trim() === "");
    const inputProps = {
      value: reportData[key] || "",
      onChange: (e) => handleChange(key, e.target.value),
      size: "large",
      status: isEmpty ? "error" : undefined,
    };

    switch (fieldConfigItem.type) {
      case "text":
        return (
          <div {...commonProps} style={{ marginBottom: "24px" }}>
            <Typography.Text strong style={{ display: "block", marginBottom: "8px", color: isEmpty ? "#ff4d4f" : "inherit" }}>
              {label}
            </Typography.Text>
            <Input {...inputProps} placeholder={`Enter ${label.toLowerCase()}`} />
          </div>
        );
      case "textarea":
        return (
          <div {...commonProps} style={{ marginBottom: "24px" }}>
            <Typography.Text strong style={{ display: "block", marginBottom: "8px", color: isEmpty ? "#ff4d4f" : "inherit" }}>
              {label}
            </Typography.Text>
            <Input.TextArea
              autoSize={{ minRows: 3 }}
              {...inputProps}
              placeholder={`Enter ${label.toLowerCase()}`}
            />
          </div>
        );
      case "autocomplete":
        const openModal = () => {
          setCurrentEditingFieldKey(key);
          setAutoCompleteModalVisible(true);
        };

        return (
          <div {...commonProps} style={{ marginBottom: "24px" }}>
            <Typography.Text strong style={{ display: "block", marginBottom: "8px", color: isEmpty ? "#ff4d4f" : "inherit" }}>
              {label}
            </Typography.Text>
            <Input.TextArea
              value={reportData[key] || ""}
              autoSize={{ minRows: 3 }}
              size="large"
              status={isEmpty ? "error" : undefined}
              placeholder={`Click to open editor with suggestions...`}
              style={{ cursor: 'pointer' }}
              onClick={openModal}
              readOnly
            />
          </div>
        );
      case "date":
        return (
          <div {...commonProps} style={{ marginBottom: "24px" }}>
            <Typography.Text strong style={{ display: "block", marginBottom: "8px", color: isEmpty ? "#ff4d4f" : "inherit" }}>
              {label}
            </Typography.Text>
            <DatePicker
              value={reportData[key]}
              onChange={(date) => handleChange(key, date)}
              size="large"
              style={{ width: "100%" }}
            />
          </div>
        );
      default:
        return null;
    }
  }, [reportData, handleChange, autocompleteOptions]);

  const renderReportDataFields = useMemo(() =>
    Object.keys(reportData).map((key) => fieldConfig[key] && renderField(key, fieldConfig[key]))
    , [reportData, renderField]);

  const steps = useMemo(() => [
    {
      title: 'Configuration',
      description: 'Setup report parameters',
      icon: <SettingOutlined />,
    },
    {
      title: 'Data Review',
      description: 'Validate report content',
      icon: <EditOutlined />,
    },
    {
      title: 'Comments',
      description: 'Add verification notes',
      icon: <CommentOutlined />,
    },
    {
      title: 'Review & Export',
      description: 'Final review and generate reports',
      icon: <CloudDownloadOutlined />,
    },
  ], []);

  const renderCurrentStep = useCallback(() => {
    switch (currentStep) {
      case 0:
        return (
          <div style={{ maxWidth: "800px", margin: "0 auto" }}>
            <Card style={{ border: '1px solid #e1e5e9', marginBottom: "24px" }}>
              <div style={{ textAlign: "center", marginBottom: "32px" }}>
                <Typography.Title level={3} style={{ marginBottom: "8px", color: '#1f2937' }}>
                  Configuration
                </Typography.Title>
                <Typography.Text type="secondary">
                  Set up your verification report parameters
                </Typography.Text>
              </div>

              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <SelectSearch
                  bgless
                  borderless
                  title="Include WTT Emissions"
                  value={useWtt ? "Yes" : "No"}
                  setValue={(val) => setUseWtt(val === "Yes")}
                  options={["Yes", "No"]}
                />

                {getCurrentPlan() === "free" ?

                  <SelectSearch
                    bgless
                    borderless
                    title="Reporting Year"
                    value={"current year"}
                    disabled
                    options={["current year"]}
                  />
                  : <SelectSearch
                    bgless
                    borderless
                    title="Reporting Year"
                    value={year}
                    setValue={setYear}
                    options={[2019, 2020, 2021, 2022, 2023, 2024, 2025].map(y => y.toString())}
                  />}
              </Space>
            </Card>

            {/* Slot Selection Section */}
            <Card
              title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>Choose Working Slot ({year})</span>
                  <Button
                    size="small"
                    onClick={loadSavedSlots}
                    icon={<ReloadOutlined />}
                    loading={slotsLoading}
                    title="Refresh saved slots"
                  >
                    Refresh
                  </Button>
                </div>
              }
              style={{ marginBottom: '24px' }}
              loading={slotsLoading}
            >
              <Typography.Text type="secondary" style={{ display: 'block', marginBottom: '24px', textAlign: 'center' }}>
                Select a slot to continue your work. Each year has 3 available slots with auto-save.
              </Typography.Text>

              {slotsLoading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <Button loading size="large" style={{ pointerEvents: 'none' }}>
                    Loading slots...
                  </Button>
                </div>
              ) : (
                <div key={`slots-container-${savedSlots.length}`}>
                  <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    {[1, 2, 3].map((slotNumber) => {
                      const existingSlot = savedSlots.find(slot => slot.slotNumber === slotNumber);
                      const isSelected = selectedSlot === slotNumber;
                      // Create a more unique key that includes slot state and render key
                      const uniqueKey = `slot_${slotNumber}_${year}_${existingSlot?.saveDate || 'empty'}_${isSelected ? 'selected' : 'unselected'}`;

                      console.log('Rendering slot:', slotNumber, 'existingSlot:', existingSlot, 'key:', uniqueKey);

                      return (
                        <div
                          key={uniqueKey}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '16px 20px',
                            borderRadius: '12px',
                            border: isSelected ? '2px solid #1890ff' : existingSlot ? '1px solid #52c41a' : '1px dashed #d9d9d9',
                            backgroundColor: isSelected ? '#f0f8ff' : existingSlot ? '#f6ffed' : '#fafafa',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            opacity: deletingSlot === slotNumber ? 0.5 : 1,
                            pointerEvents: deletingSlot === slotNumber ? 'none' : 'auto'
                          }}
                          onClick={(e) => {
                            if (existingSlot) {
                              loadFromSlot(slotNumber);
                            } else {
                              setSelectedSlot(slotNumber);
                              setIsUsingOldSlotData(false);
                              setEmissionMismatchWarning(null);
                              setCurrentStep(1);
                            }
                          }}
                        >
                          {/* Left side - Slot info */}
                          <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <Typography.Text strong style={{ fontSize: '18px' }}>
                                  {existingSlot?.slotName || `Slot ${slotNumber}`}
                                </Typography.Text>
                                {updatingSlot !== slotNumber ? (
                                  <Button
                                    type="text"
                                    size="small"
                                    icon={<EditOutlined />}
                                    onClick={(e) => {
                                      if (!existingSlot) return window.alert("please create slot first.")
                                      e.stopPropagation();
                                      handleSlotNameEdit(slotNumber, existingSlot?.slotName || `Slot ${slotNumber}`);
                                    }}
                                    style={{ color: '#1890ff', padding: '4px' }}
                                    title="Edit slot name"
                                  />
                                ) : (
                                  <Button
                                    type="text"
                                    size="small"
                                    loading
                                    style={{ padding: '4px' }}
                                  />
                                )}
                              </div>
                              {existingSlot ? (
                                <Space size="small">
                                  <Badge count={`Step ${existingSlot.data.currentStep + 1}/4`} style={{ backgroundColor: '#52c41a' }} />
                                  <Badge count={existingSlot.data.useWtt ? 'WTT' : 'No WTT'} style={{ backgroundColor: '#722ed1' }} />
                                </Space>
                              ) : (
                                <Badge count="Empty" style={{ backgroundColor: '#d9d9d9', color: '#666' }} />
                              )}
                            </div>
                            {existingSlot && (
                              <Typography.Text type="secondary" style={{ fontSize: '14px' }}>
                                Saved {new Date(existingSlot.saveDate).toLocaleDateString()} at {new Date(existingSlot.saveDate).toLocaleTimeString()}
                              </Typography.Text>
                            )}
                          </div>

                          {/* Right side - Action buttons */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            {existingSlot && (
                              <Popconfirm
                                title="Delete this save?"
                                description="This action cannot be undone."
                                onConfirm={(e) => {
                                  e?.stopPropagation();
                                  deleteFromSlot(slotNumber);
                                }}
                                okText="Yes"
                                cancelText="No"
                                disabled={deletingSlot === slotNumber}
                              >
                                <Button
                                  danger
                                  size="small"
                                  style={{ borderRadius: '6px' }}
                                  onClick={(e) => e.stopPropagation()}
                                  loading={deletingSlot === slotNumber}
                                  disabled={deletingSlot === slotNumber}
                                >
                                  {deletingSlot === slotNumber ? 'Deleting...' : 'Delete'}
                                </Button>
                              </Popconfirm>
                            )}
                            <Button
                              type={isSelected ? "primary" : existingSlot ? "primary" : "dashed"}
                              size="large"
                              style={{
                                borderRadius: '8px',
                                minWidth: '140px',
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 'bold'
                              }}
                              disabled={deletingSlot === slotNumber || updatingSlot === slotNumber}
                            >
                              {existingSlot ? 'CONTINUE' : 'START NEW'}
                            </Button>
                          </div>
                        </div>
                      );
                    })}
                  </Space>
                </div>
              )}
            </Card>
          </div>
        );
      case 1:
        if (!selectedSlot) {
          setCurrentStep(0);
          return null;
        }
        return (
          <div style={{ maxWidth: "800px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <Typography.Title level={3} style={{ marginBottom: "8px", color: '#1f2937' }}>
                Data Review
              </Typography.Title>
              <Typography.Text type="secondary">
                Review and validate report data
              </Typography.Text>
            </div>

            <Card style={{ border: '2px solid #e1e5e9', overflowY: "auto" }}>
              {renderReportDataFields}
            </Card>

            <div style={{ textAlign: "center", marginTop: "32px" }}>
              <Space size="middle">
                <Button
                  type="primary"
                  size="large"
                  onClick={() => setCurrentStep(2)}
                  icon={<CommentOutlined />}
                >
                  Continue
                </Button>
              </Space>
            </div>
          </div>
        );
      case 2:
        if (!selectedSlot) {
          setCurrentStep(0);
          return null;
        }
        return (
          <div style={{ maxWidth: "100%", margin: 0, padding: 0 }}>
            <div style={{ textAlign: "center", marginBottom: "24px" }}>
              <div style={{ fontSize: '32px', marginBottom: '16px' }}>💬</div>
              <Typography.Title level={3} style={{ marginBottom: "8px", color: '#1f2937' }}>
                Comments
              </Typography.Title>
              <Typography.Text type="secondary">
                Add verification comments
              </Typography.Text>
            </div>

            <Card style={{ border: '1px solid #e1e5e9' }}>
              <CommentsTable
                dataSource={tableDataSource}
                setDataSource={setTableDataSource}
                year={year}
                startDate={reportData?.startDate}
                endDate={reportData?.endDate}
                onCalculatedDataChange={(data) => {
                  setCalculatedCommentsTable(data);
                }}
                onDividedRecordsChange={setCurrentDividedRecords}
                loadedData={loadedData}
              />
            </Card>

            <div style={{ textAlign: "center", marginTop: "24px" }}>
              <Space size="middle">
                <Button
                  size="large"
                  onClick={() => setCurrentStep(1)}
                  icon={<EditOutlined />}
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  size="large"
                  onClick={() => setCurrentStep(3)}
                  icon={<CloudDownloadOutlined />}
                >
                  Continue
                </Button>
              </Space>
            </div>
          </div>
        );
      case 3:
        if (!selectedSlot) {
          setCurrentStep(0);
          return null;
        }
        return (
          <div style={{ maxWidth: "800px", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: "32px" }}>
              <Typography.Title level={3} style={{ marginBottom: "8px", color: '#1f2937' }}>
                Review & Export
              </Typography.Title>
              <Typography.Text type="secondary">
                Final review and generate your verification reports
              </Typography.Text>
            </div>

            {/* Reviewer and Authorizer Section */}
            <Card style={{ border: '1px solid #e1e5e9', marginBottom: "24px" }}>
              <Typography.Title level={4} style={{ marginBottom: "16px" }}>
                Reviewer & Authorizer
              </Typography.Title>

              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <SelectSearch
                  bgless
                  borderless
                  title="Reviewer"
                  value={reviewer}
                  setValue={setReviewer}
                  options={consultants?.map((c) => `${c.firstName} ${c.lastName}`)}
                />

                <SelectSearch
                  bgless
                  borderless
                  title="Authorizer"
                  value={authorizer}
                  setValue={setAuthorizer}
                  options={consultants?.map((c) => `${c.firstName} ${c.lastName}`)}
                />

                {/* Show reviewer details if selected */}
                {reviewer && (
                  <div>
                    <Typography.Text strong style={{ display: "block", marginBottom: "8px" }}>
                      Reviewer Details
                    </Typography.Text>
                    <Input.TextArea
                      value={reportData?.reviewer_details_without_phone || ''}
                      onChange={(e) => handleChange('reviewer_details_without_phone', e.target.value)}
                      autoSize={{ minRows: 2 }}
                      placeholder="Reviewer details will be auto-populated..."
                      style={{ backgroundColor: '#f9f9f9' }}
                    />
                  </div>
                )}

                {/* Show authorizer details if selected */}
                {authorizer && (
                  <div>
                    <Typography.Text strong style={{ display: "block", marginBottom: "8px" }}>
                      Authorizer Details
                    </Typography.Text>
                    <Input.TextArea
                      value={reportData?.authorizer_details_without_phone || ''}
                      onChange={(e) => handleChange('authorizer_details_without_phone', e.target.value)}
                      autoSize={{ minRows: 2 }}
                      placeholder="Authorizer details will be auto-populated..."
                      style={{ backgroundColor: '#f9f9f9' }}
                    />
                  </div>
                )}
              </Space>
            </Card>

            {isDownloading && (
              <Card style={{ marginBottom: '24px', border: '1px solid #1890ff' }}>
                <div style={{ textAlign: 'center', padding: '16px' }}>
                  <Typography.Text strong style={{ color: '#1890ff' }}>
                    Generating Report...
                  </Typography.Text>
                  <Progress
                    percent={Math.round(downloadProgress)}
                    status="active"
                    style={{ marginTop: '12px' }}
                  />
                </div>
              </Card>
            )}

            <Card style={{ border: '1px solid #e1e5e9' }}>
              <Typography.Title level={4} style={{ marginBottom: "16px" }}>
                Export Reports
              </Typography.Title>

              <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <div>
                  <Typography.Text strong>1. Download Verification Report (DOCX)</Typography.Text>
                  <Typography.Text type="secondary" style={{ display: 'block', marginTop: '4px' }}>
                    Generate the verification report document
                  </Typography.Text>
                </div>
                <Button
                  type="primary"
                  size="large"
                  icon={<DownloadOutlined />}
                  onClick={() => setReportTypeModalVisible(true)}
                  disabled={isDownloading}
                  style={{ width: "100%", height: "48px" }}
                >
                  Download Verification Report
                </Button>

                <Divider />

                <div>
                  <Typography.Text strong>2. Verify and convert to PDF</Typography.Text>
                  <Typography.Text type="secondary" style={{ display: 'block', marginTop: '4px' }}>
                    Review the document and convert to PDF format
                  </Typography.Text>
                </div>

                <div>
                  <Typography.Text strong>3. Upload PDF to get Full Report</Typography.Text>
                  <Typography.Text type="secondary" style={{ display: 'block', marginTop: '4px' }}>
                    Upload the PDF to generate the complete report package
                  </Typography.Text>
                </div>
                <CbfReportDownload
                  renderThisInstead={
                    <Button
                      size="large"
                      icon={<FileTextOutlined />}
                      disabled={isDownloading}
                      style={{ width: "100%", height: "48px" }}
                    >
                      Upload PDF for Full Report
                    </Button>
                  }
                  callFunctionInsteadOfDownload={mergeAndDownloadPDF}
                  year={year}
                  results={store.getState().app.results}
                />
              </Space>
            </Card>

            <div style={{ textAlign: "center", marginTop: "32px" }}>
              <Button
                size="large"
                onClick={() => setCurrentStep(2)}
                icon={<CommentOutlined />}
              >
                Back
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  }, [currentStep, useWtt, year, reviewer, authorizer, consultants, renderReportDataFields, tableDataSource, setTableDataSource, isDownloading, downloadProgress]);

  const ReportTypeModal = useMemo(() => (
    <Modal
      title="Select Report Type"
      open={reportTypeModalVisible}
      onCancel={() => setReportTypeModalVisible(false)}
      footer={null}
      centered
      width={500}
    >
      <div style={{ padding: "16px 0px" }}>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Button
            type="primary"
            size="large"
            onClick={() => handleDownloadReport(1)}
            disabled={isDownloading}
            style={{ width: "100%", height: "48px" }}
          >
            Simple Report
          </Button>

          <Button
            type="primary"
            size="large"
            onClick={() => handleDownloadReport(2)}
            disabled={isDownloading}
            style={{ width: "100%", height: "48px", backgroundColor: "#722ed1", borderColor: "#722ed1" }}
          >
            MX Report
          </Button>

          <Button
            type="primary"
            size="large"
            onClick={() => handleDownloadReport(3)}
            disabled={isDownloading}
            style={{ width: "100%", height: "48px", backgroundColor: "#fa8c16", borderColor: "#fa8c16" }}
          >
            DC Report
          </Button>
        </Space>

        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <Button onClick={() => setReportTypeModalVisible(false)}>
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  ), [reportTypeModalVisible, handleDownloadReport, isDownloading]);

  // Show loading until consultants are loaded
  if (!results || !consultantsLoaded) return <Loading />;

  if (!consultant)
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5'
      }}>
        <Card style={{ maxWidth: "500px", textAlign: "center" }}>
          <div style={{ fontSize: '48px', marginBottom: '24px' }}>🔐</div>
          <Typography.Title level={4} style={{ marginBottom: "16px" }}>
            Authentication Required
          </Typography.Title>
          <Typography.Paragraph style={{ marginBottom: "24px" }}>
            Please log in with your consultant credentials.
          </Typography.Paragraph>
        </Card>
      </div>
    );


  const goBackAndReset = () => {
    setSelectedSlot(null);
    setIsUsingOldSlotData(false);
    setEmissionMismatchWarning(null);
    setCurrentStep(0);
  }

  return (

    <div style={{ minHeight: "100vh", backgroundColor: '#f5f5f5', position: 'relative' }}>
      <Button onClick={() => { if (window.confirm("Are you sure you want to exit?")) goBackAndReset() }}>Exit Save</Button>
      {/* Emission Mismatch Warning */}
      {emissionMismatchWarning && (
        <div style={{ margin: '16px', marginBottom: '0' }}>
          <Card
            style={{
              border: '2px solid #fa8c16',
              backgroundColor: '#fff7e6',
              borderRadius: '8px'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ fontSize: '24px' }}>⚠️</div>
              <div style={{ flex: 1 }}>
                <Typography.Text strong style={{ color: '#fa8c16', display: 'block', marginBottom: '8px' }}>
                  Emission Data Mismatch Detected
                </Typography.Text>
                <Typography.Text style={{ display: 'block', marginBottom: '8px' }}>
                  The current calculations don't match the saved slot data. Using saved slot data for consistency.
                </Typography.Text>
                <div style={{ display: 'flex', gap: '24px', fontSize: '14px' }}>
                  <div>
                    <Typography.Text strong>Market-Based:</Typography.Text>
                    <br />
                    <Typography.Text>Saved: {emissionMismatchWarning.oldMarketBased}</Typography.Text>
                    <br />
                    <Typography.Text>Current: {emissionMismatchWarning.newMarketBased}</Typography.Text>
                  </div>
                  <div>
                    <Typography.Text strong>Location-Based:</Typography.Text>
                    <br />
                    <Typography.Text>Saved: {emissionMismatchWarning.oldLocationBased}</Typography.Text>
                    <br />
                    <Typography.Text>Current: {emissionMismatchWarning.newLocationBased}</Typography.Text>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <Button
                  type="default"
                  onClick={updateToNewValues}
                  style={{ borderColor: '#1890ff', color: '#1890ff' }}
                >
                  Update New Values
                </Button>
                <Button
                  type="primary"
                  danger
                  onClick={goBackAndReset}
                >
                  Create New Slot
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )}

      {/* Floating Settings Button */}
      <Button
        type="primary"
        shape="circle"
        icon={<ToolOutlined />}
        size="large"
        onClick={() => setSettingsModalVisible(true)}
        style={{
          display: "none",
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          zIndex: 1000,
          width: '56px',
          height: '56px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        }}
        title="Verification Settings"
      />

      {/* Settings Modal */}
      <Modal
        title="Verification Settings"
        open={settingsModalVisible}
        onCancel={() => setSettingsModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setSettingsModalVisible(false)}>
            Close
          </Button>
        ]}
        width={400}
      >
        <div style={{ padding: '16px 0' }}>
          <Typography.Title level={5} style={{ marginBottom: '16px' }}>
            Cache Options
          </Typography.Title>
          <Typography.Paragraph type="secondary" style={{ marginBottom: '16px' }}>
            Choose how autocomplete suggestions are stored and shared.
          </Typography.Paragraph>

          <div style={{ marginBottom: '16px' }}>
            <Checkbox
              checked={useCommonCache}
              onChange={(e) => setUseCommonCache(e.target.checked)}
            >
              Use common cache for all companies
            </Checkbox>
          </div>

          <div style={{ padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
            <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
              {useCommonCache
                ? "Suggestions will be shared across all companies using key: 'commonVerificationCompany'"
                : `Suggestions will be specific to: "${getCacheKey()}"`
              }
            </Typography.Text>
          </div>
        </div>
      </Modal>

      <div style={{ margin: "0 auto", padding: '16px' }}>
        <div style={{ marginBottom: "32px", backgroundColor: 'white', borderRadius: '8px', padding: '16px', border: '1px solid #e1e5e9' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              {selectedSlot && (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Badge count={`Slot ${selectedSlot}`} style={{ backgroundColor: '#1890ff' }} />
                  <Badge count={useWtt ? 'WTT' : 'No WTT'} style={{ backgroundColor: '#722ed1' }} />
                </div>
              )}
            </div>

            {isAutoSaving && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#1890ff' }}>
                <SaveOutlined spin />
                <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
                  Auto-saving...
                </Typography.Text>
              </div>
            )}
          </div>

          <Steps current={currentStep} items={steps} />
        </div>

        {renderCurrentStep()}
        {ReportTypeModal}

        {/* AutoComplete Modal */}
        <AutoCompleteModal
          key={currentEditingFieldKey}
          visible={autoCompleteModalVisible}
          onCancel={() => setAutoCompleteModalVisible(false)}
          onSave={handleAutoCompleteModalSave}
          title={`Edit ${currentEditingFieldKey.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()).replaceAll("_", " ")}`}
          value={reportData[currentEditingFieldKey] || ""}
          suggestions={autocompleteOptions[currentEditingFieldKey] || []}
          placeholder={`Enter ${currentEditingFieldKey.replace(/([A-Z])/g, " $1").toLowerCase()}...`}
          onAddSuggestion={handleAddSuggestionFromAutoCompleteModal}
          onRemoveSuggestion={handleRemoveSuggestionFromAutoCompleteModal}
          fieldKey={currentEditingFieldKey}
        />
      </div>
    </div>
  );
};

const pageCSS = {
  backgroundColor: 'white',
  borderRadius: '8px',
  minHeight: '400px',
  padding: '8px',
  border: '1px solid #e1e5e9'
}

export default function VerificationWrapper() {
  const results = useSelector(selectResults);
  const [consultant, setConsultant] = useAtom(consultantAtom);
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [renderKey, setRenderKey] = useState(0);

  // these are for the verification page
  const [year, setYear] = useState(getCurrentYear()?.toString());
  const [useWtt, setUseWtt] = useState(true);
  if (!results) return <Loading />;

  const consultantMenu = {
    items: [
      {
        key: 'details',
        label: 'Personal Details',
        icon: <UserOutlined />,
        onClick: () => setDetailsModalVisible(true)
      },
      {
        key: 'logout',
        label: 'Logout',
        icon: <LogoutOutlined />,
        onClick: () => {
          if (window.confirm("Confirm Consultant Logout?")) {
            message.success("Logged out, reloading...");
            setConsultant(null);
            localStorage.removeItem("consultant_token");
            window.location.reload();
          }
        }
      }
    ]
  };

  return (
    <div key={renderKey} style={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      minHeight: "100vh",
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "16px 24px",
        backgroundColor: 'white',
        borderBottom: '1px solid #e1e5e9',
        marginBottom: "16px"
      }}>
        <div>
          <Typography.Title level={4} style={{ margin: 0, color: '#1f2937' }}>
            Welcome, {consultant?.firstName} {consultant?.lastName}
          </Typography.Title>
          <Typography.Text type="secondary" style={{ fontSize: '14px' }}>
            Verification Dashboard
          </Typography.Text>
        </div>
        <Dropdown menu={consultantMenu} trigger={['click']}>
          <Button icon={<UserOutlined />}>
            Account <DownOutlined />
          </Button>
        </Dropdown>
      </div>

      <Modal
        title="Personal Details"
        open={detailsModalVisible}
        onCancel={() => setDetailsModalVisible(false)}
        footer={[
          <Button
            key="signature"
            type="link"
            onClick={() => downloadFileFromStorage(consultant?.signature, "your_signature.png")}
            icon={<DownloadOutlined />}
          >
            Download Signature
          </Button>,
          <Button key="close" onClick={() => setDetailsModalVisible(false)}>
            Close
          </Button>
        ]}
        width={600}
      >
        <div style={{ marginBottom: "16px" }}>
          <Typography.Text strong>Details:</Typography.Text>
          <pre style={{
            marginTop: "8px",
            whiteSpace: "pre-wrap",
            padding: "12px",
            borderRadius: "6px",
            border: "1px solid #d9d9d9",
            backgroundColor: '#fafafa'
          }}>
            {consultant?.details_for_template}
          </pre>
        </div>
        <div>
          <Typography.Text strong>Summary:</Typography.Text>
          <pre style={{
            marginTop: "8px",
            whiteSpace: "pre-wrap",
            padding: "12px",
            borderRadius: "6px",
            border: "1px solid #d9d9d9",
            backgroundColor: '#fafafa'
          }}>
            {consultant?.summary_for_template}
          </pre>
        </div>
      </Modal>

      <div style={{ flex: 1, padding: "0 16px" }}>
        <Tabs
          defaultActiveKey="4"
          style={{ height: "100%" }}
          type="card"
          size="large"
        >
          <TabPane tab={<span><BuildOutlined /> Functions</span>} key="1">
            <div style={pageCSS}>
              <ResultFunctions />
            </div>
          </TabPane>
          <TabPane tab={<span><UserOutlined /> Permissions</span>} key="2">
            <div style={pageCSS}>
              <Permissions />
            </div>
          </TabPane>
          {/* <TabPane tab={<span><BuildOutlined /> Boundary (Testing)</span>} key="bou">
            <div style={pageCSS}>
              <Boundry userview={false} />
            </div>
          </TabPane> */}
          <TabPane tab={<span><EditOutlined /> Edit Plan</span>} key="3">
            <div style={pageCSS}>
              <Companies is_consultant_page={true} />
            </div>
          </TabPane>
          <TabPane tab={<span><CheckCircleOutlined /> Verification</span>} key="4">
            <div style={pageCSS}>
              <Verification rerender={() => setRenderKey(prev => prev + 1)} useWtt={useWtt} setUseWtt={setUseWtt} year={year} setYear={setYear} />
            </div>
          </TabPane>
          <TabPane tab={<span><SettingOutlined /> Lock Data</span>} key="5">
            <div style={pageCSS}>
              <LockData />
            </div>
          </TabPane>
          <TabPane tab={<span><NumberOutlined /> Analysis</span>} key="6">
            <div style={pageCSS}>
              <AnalysisConsultant />
            </div>
          </TabPane>
          <TabPane tab={<span><FileTextOutlined /> Results</span>} key="7">
            <div style={pageCSS}>
              <AnalysisResult />
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
}

